module.exports = __webpack_public_path__ + "static/media/2_en.17d24085.png";